// extracted by mini-css-extract-plugin
module.exports = {"image":"shopItem_image__PEjDv","item":"shopItem_item__ANKtd","link":"shopItem_link__VERW8"};